<ion-header>
  <ion-toolbar>
    <ion-segment id="topic-bar" scrollable>
      <ion-segment-button *ngFor="let topic of topics" [routerLink]="['/news', topic.name]" >
        <ion-label class="topic-label" *ngIf="(authService.currentUser$ | async) as user">{{ 'TOPIC.' + topic.name | translate }}</ion-label>
      </ion-segment-button>
    </ion-segment>
  </ion-toolbar>
</ion-header>

<ion-content>
  <p id="noBookmarks" *ngIf="isBookmarksView && previewBlocks.length == 0"> {{ 'HOME.NO_BOOKMARKS' | translate }} </p>
  <ion-grid id="home-grid">
    <ion-row *ngFor="let block of previewBlocks; let i = index">
      <ion-col>
        <div class="card-container" [id]="'preview-block-' + i" >
          <div [id]="'highlight-article-' + i" class="highlight-card" [routerLink]="['/article',block.articles[0].app_article]">
            <img *ngIf="block.articles[0].thumbnail" class="article-image" alt="article image" [src]="block.articles[0].thumbnail"/>
            <div class="card-text">
              <ion-text *ngIf="(authService.currentUser$ | async) as user"><h1 class="highlight-title">{{ getArticleTitle(block.articles[0].title, block.language, level) }}</h1></ion-text>
              <div class="card-subtitle">
                <div class="publisher-info">
                  <img *ngIf="block.articles[0].source.icon" class="publisher-image" alt="publisher image" [src]="block.articles[0].source.icon">
                  <p>{{ block.articles[0].source.name }}</p>
                </div>
                <p>{{ getRelativeTime(block.articles[0].publishDate) }}</p>
              </div>
            </div>
          </div>
          <div *ngIf="block.articles.length > 1" class="divider"></div>
          <div class="related-card">
            <ion-list lines="none">
              <ion-item *ngFor="let article of block.articles | slice:1" class="related-item" [routerLink]="['/article',article.app_article]">
                <div class="related-info">
                  <div class="card-subtitle" >
                    <div class="publisher-info">
                      <img *ngIf="article.source.icon" class="publisher-image" alt="publisher image" [src]="article.source.icon">
                      <p>{{ article.source.name }}</p>
                    </div>
                    <p>{{ getRelativeTime(article.publishDate) }}</p>
                  </div>
                  <ion-text *ngIf="(authService.currentUser$ | async) as user"><h3 class="related-title">{{ getArticleTitle(article.title, block.language, level) }}</h3></ion-text>
                </div>
              </ion-item>
          </ion-list>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-infinite-scroll threshold="100px" (ionInfinite)="loadArticles($event)" [disabled]="allLoaded">
    <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="{{ 'LOADING' | translate }}"></ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>